import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/test-linting-workflow/test-linting-workflow/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Hero = makeShortcode("Hero");
const DiscoverBlock = makeShortcode("DiscoverBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Hero slots="heading, text" background="rgb(19, 93, 183)" mdxType="Hero" />
    <h1 {...{
      "id": "support"
    }}>{`Support`}</h1>
    <p>{`Learn where to ask questions, report bugs, make feature requests, and spark discussions.`}</p>
    <h2 {...{
      "id": "feedback"
    }}>{`Feedback`}</h2>
    <p>{`You've got a place to start discussions.`}</p>
    <DiscoverBlock slots="image, heading, link, text" width="25%" mdxType="DiscoverBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "512px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/test-linting-workflow/static/5899ae6e7c46d7bb61ca5ad2000bd51b/cb523/experience_cloud.webp 320w", "/test-linting-workflow/static/5899ae6e7c46d7bb61ca5ad2000bd51b/1bb89/experience_cloud.webp 512w"],
            "sizes": "(max-width: 512px) 100vw, 512px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/test-linting-workflow/static/5899ae6e7c46d7bb61ca5ad2000bd51b/72799/experience_cloud.png 320w", "/test-linting-workflow/static/5899ae6e7c46d7bb61ca5ad2000bd51b/01e7c/experience_cloud.png 512w"],
            "sizes": "(max-width: 512px) 100vw, 512px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/test-linting-workflow/static/5899ae6e7c46d7bb61ca5ad2000bd51b/01e7c/experience_cloud.png",
            "alt": "Adobe Experience Cloud",
            "title": "Adobe Experience Cloud",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "developer-forum"
    }}>{`Developer forum`}</h3>
    <p><a parentName="p" {...{
        "href": "https://adobe.io"
      }}>{`Get started`}</a></p>
    <p>{`Open discussion and support with community experts and Adobe staff.`}</p>
    <DiscoverBlock slots="link, text" width="25%" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "https://adobe.io"
      }}>{`Experience league`}</a>{` `}</p>
    <p>{`Tutorials and videos for the whole community.`}</p>
    <DiscoverBlock slots="link, text" width="25%" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "https://adobe.io"
      }}>{`Experience forum`}</a>{` `}</p>
    <p>{`Forum to get help and help others`}</p>
    <h2 {...{
      "id": "community"
    }}>{`Community`}</h2>
    <p>{`You've got a place to join the conversation.`}</p>
    <DiscoverBlock slots="image, heading, link, text" width="100%" mdxType="DiscoverBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "512px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/test-linting-workflow/static/2da12b7265d4242924ab4071b5667b48/cb523/stack-overflow.webp 320w", "/test-linting-workflow/static/2da12b7265d4242924ab4071b5667b48/1bb89/stack-overflow.webp 512w"],
            "sizes": "(max-width: 512px) 100vw, 512px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/test-linting-workflow/static/2da12b7265d4242924ab4071b5667b48/72799/stack-overflow.png 320w", "/test-linting-workflow/static/2da12b7265d4242924ab4071b5667b48/01e7c/stack-overflow.png 512w"],
            "sizes": "(max-width: 512px) 100vw, 512px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/test-linting-workflow/static/2da12b7265d4242924ab4071b5667b48/01e7c/stack-overflow.png",
            "alt": "Stack Overflow",
            "title": "Stack Overflow",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "stack-overflow"
    }}>{`Stack Overflow`}</h3>
    <p><a parentName="p" {...{
        "href": "https://adobe.io"
      }}>{`Explore`}</a></p>
    <p>{`Developer Q&A using a specific tag.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      